module.exports = "//static.hsappstatic.net/salesImages/static-1.403/meetings/setup-example-headline.png"